import React, { useState, useEffect } from 'react'
import { Button, Modal, Table, Tree, Switch, Input, message } from 'antd';
import axios from 'axios';
import { DeleteOutlined, EditOutlined, ExclamationCircleFilled } from '@ant-design/icons';


const { confirm } = Modal;

export default function RoleList() {
  const [messageApi, contextHolder] = message.useMessage();
  const [dataSource, setDataSource] = useState([]);
  const [rightList, setRightList] = useState([]);
  const [currentSelectData, setCurrentSelectData] = useState([])
  const [currentId, setCurrentId] = useState(0)
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [addDataSource, setAddDataSource] = useState({
    name: '',
    groupType: 2,
    permissions: [],
    default: 0,
    enable: 1,
    create_admin_id: 0//TODO:登入功能完成後刪除
  });
  const groupTypeStringMapping = {
    1: '管理員',
    2: '員工'
  }
  const clearAddDataSource = () => {
    setAddDataSource({
      name: '',
      groupType: 2,
      permissions: [],
      default: 0,
      enable: 1,
      create_admin_id: 0//TODO:登入功能完成後刪除
    })
  }

  useEffect(()=>{
    axios.get('/api/group-permission').then(res=>{
      setDataSource(res.data)
    })
  },[])

  useEffect(()=>{
    axios.get('/api/page-route').then(res=>{
      setRightList(res.data)
    })
  },[])

  //回傳更新資料至後端
  const updateGroupPermissionData = (data) => {
    console.log(data,'更新資料')
    axios.patch(`/api/group-permission/${data.id}`,data)
    .then(res=>{
      //同步dataSource
      setDataSource(dataSource.map(value=>{
        if(value.id === data.id){
          return data;
        }
        return value
      }))
      success('資料更新成功')
    })
    .catch(err=>{
      if(typeof err.response.data.errors === 'object' ){
        let error_meaage = Object.values(err.response.data.errors).join(' ')
        error(error_meaage)
      }else{
        error('錯誤，請洽管理員')
        console.error(err)
      }
    })

  }

  const columns = [
    {
      title: '群組名稱',
      dataIndex: 'name',
    },
    {
      title: '權限種類',
      dataIndex:'groupType',
      render:(value)=>{
        return <div>
          {groupTypeStringMapping[value]}
        </div>
      }
    },
    {
      title: '預設權限',
      dataIndex:'default',
      render:(value)=>{
        return <div>
          {value === 1? '是':'否'}
        </div>
      }
    },
    {
      title: '啟用',
      render:(item)=>{
        return <Switch checked={item.enable === 1} onChange={()=>(switchGroupPermission(item))} disabled={item.default === 1 || item.id === 1} />
      }
    },
    {
      title: '操作',
      render:(item)=>{
        return <div>
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            onClick={()=>{
              showModal()
              setCurrentSelectData(item)
              setCurrentId(item.id)
            }}
          />
        </div>
      }
    },
  ]

  const switchGroupPermission = (item)=>{
    item.enable = item.enable===1?0:1;
    updateGroupPermissionData(item)//回傳後端
  }

  const confirmDel = (item)=>{
    confirm({
      title: '您確認是否要刪除此權限?',
      icon: <ExclamationCircleFilled />,
      onOk() {
        deleteRole(item)
      },
    });
  }
  const deleteRole = (item) =>{
    //TODO: 刪除群組功能，待使用者功能建立完成後實作
    // setDataSource(dataSource.filter(data=>data.id !== item.id))
    // axios.delete(`/roles/${item.id}`)
  }

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
    updateGroupPermissionData(currentSelectData);//回傳後端
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const onCheck = (checkedKeys) => {
    setCurrentSelectData({...currentSelectData,...{permissions:checkedKeys.checked}})
  };
  const handleAddOk = () => {
    setIsAddModalOpen(false)
    //TODO: 檢查必填
    axios.post('/api/group-permission',addDataSource)
    .then(res=>{
      //同步dataSource
      let newDataSource = [...dataSource]
      newDataSource.push(res.data)
      setDataSource(newDataSource);
      clearAddDataSource()
      success('群組權限新增成功')
    })
    .catch(err=>{
      if(typeof err.response.data.errors === 'object' ){
        let error_meaage = Object.values(err.response.data.errors).join(' ')
        error(error_meaage)
      }else{
        error('錯誤，請洽管理員')
        console.error(err)
      }
    })
  }
  const handleAddCancel = () =>{
    setIsAddModalOpen(false)
    clearAddDataSource();
  }
  const onAddCheck = (checkedKeys) =>{
    setAddDataSource({...addDataSource,...{permissions:checkedKeys.checked}})
  }

  const success = (message) => {
    messageApi.open({
      type: 'success',
      content: message,
    });
  };

  const error = (error) => {
    messageApi.open({
      type: 'error',
      content: error,
    });
  };

  return (
    <div>
      {contextHolder}
      <Button type="primary" onClick={()=>setIsAddModalOpen(true)}>新增群組</Button>
      <p></p>
      <Table dataSource={dataSource} columns={columns} rowKey="id"/>
      <Modal title="新增權限群組" open={isAddModalOpen} onOk={handleAddOk} onCancel={handleAddCancel}>
        <div>
            <h3>群組名稱:</h3>
            <Input value={addDataSource.name} onChange={(e)=>{
              setAddDataSource({...addDataSource,...{name:e.target.value}})
            }}/>
            <p></p>
            <h3>新增權限:</h3>
            <Tree
              checkable
              fieldNames={{ title:'label' }}
              checkedKeys={addDataSource.permissions}
              onCheck={onAddCheck}
              treeData={rightList}
              defaultExpandAll={true}
              checkStrictly={true}
            />
        </div>
      </Modal>
      <Modal title="修改權限群組" open={isModalOpen} onOk={handleOk} onCancel={handleCancel}>
        <div>
            <h3>群組名稱:</h3>
            <Input value={currentSelectData.name} onChange={(e)=>{setCurrentSelectData({...currentSelectData,...{name:e.target.value}})}}/>
            <p></p>
            <h3>修改權限:</h3>
            <Tree
              checkable
              fieldNames={{ title:'label' }}
              checkedKeys={currentSelectData.permissions}
              onCheck={onCheck}
              treeData={rightList}
              defaultExpandAll={true}
              checkStrictly={true}
            />
        </div>
      </Modal>
    </div>
  )
}
